export const LIVE_QUADRANT_ORDER = [-1, -2, -3, -4, -5, -6, 5, 4, 3, 2, 1, 0];
export const QUADRANT_ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const INFRARED_MIN_VALUE = 200; // fahrenheit
export const INFRARED_MAX_VALUE = 1000; // fahrenheit

export enum SidewallSectionName {
  Slagline = "Slagline",
  Transition = "Transition",
  UpperBarrel = "Upper Barrel",
  LowerBarrel = "Lower Barrel",
}

export type HeatMapVisualMapColor = {
  min: number;
  max?: number;
  color: string;
};

export const positionSuffixMap = [
  { x: -3, y: 0 },
  { x: -2.5, y: -1.5 },
  { x: -1.5, y: -2.5 },
  { x: 0, y: -3 },
  { x: 1.5, y: -2.5 },
  { x: 2.5, y: -1.5 },
  { x: 3, y: 0 },
  { x: 2.5, y: 1.5 },
  { x: 1.5, y: 2.5 },
  { x: 0, y: 3 },
  { x: -1.5, y: 2.5 },
  { x: -2.5, y: 1.5 },
];
